import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const FiltersBar = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
`;

export const StatsBar = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const StatCard = styled.div`
  background: ${props => props.$bgColor || '#f8fafc'};
  border: 1px solid ${props => props.$borderColor || '#e2e8f0'};
  border-radius: 8px;
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
`;

export const StatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${props => props.$color || COLORS.PRIMARY};
`;

export const StatLabel = styled.div`
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
  text-transform: uppercase;
`;

export const AuditRow = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #f1f5f9;
  gap: 16px;
  transition: background-color 0.15s;

  &:hover {
    background-color: #f8fafc;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ActionBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 400;
  white-space: nowrap;
  flex-shrink: 0;
  background-color: ${props => (props.$destructive ? '#FEE2E2' : '#E0E7FF')};
  color: ${props => (props.$destructive ? '#DC2626' : '#4338CA')};
`;

export const RowMain = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RowHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const RowTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${COLORS.PRIMARY};
`;

export const RowMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #64748B;
`;

export const MetaStrong = styled.span`
  color: #334155;
  font-weight: 500;
`;

export const RowRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  flex-shrink: 0;
`;

export const Timestamp = styled.div`
  font-size: 12px;
  color: #94A3B8;
  white-space: nowrap;
  flex-shrink: 0;
  text-align: right;
  min-width: 140px;
`;

export const ReasonBlock = styled.div`
  display: inline-flex;
  align-items: baseline;
  width: fit-content;
  max-width: 100%;
  background: #FFFBEB;
  border: 1px solid #FDE68A;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  color: #92400E;
`;

export const ReasonLabel = styled.span`
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.03em;
  margin-right: 6px;
`;

export const DetailToggle = styled.button`
  background: none;
  border: none;
  color: ${COLORS.SECONDARY};
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  padding: 2px 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: fit-content;

  &:hover {
    color: ${COLORS.PRIMARY};
    text-decoration: underline;
  }
`;

export const SnapshotPre = styled.pre`
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 6px;
  padding: 12px;
  font-size: 12px;
  line-height: 1.5;
  overflow: auto;
  max-height: 320px;
  margin: 4px 0 0 0;
`;

export const DeletedTag = styled.span`
  font-size: 11px;
  font-style: italic;
  color: #94A3B8;
`;

export const LoadMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px;
  margin-top: 16px;
  border: 1px dashed #CBD5E1;
  border-radius: 8px;
  background: transparent;
  color: ${COLORS.PRIMARY};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #F8FAFC;
    border-color: ${COLORS.PRIMARY};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
